<div [formGroup]="form">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" [formArrayName]="property" *ngIf="INITTED">
    <div *ngFor="let attr of attributeArray.controls; index as i" [formGroupName]="i">
      <ng-container
        [ngTemplateOutlet]="templateTypes[attr.get('config').value.inputType]"
        [ngTemplateOutletContext]="{ attr: attr, index: i }"
      ></ng-container>
    </div>
  </div>
</div>

<div class="flex flex-col" *ngIf="keywords && INITTED" [formGroup]="form">
  <mat-form-field appearance="fill">
    <mat-label>Taggar</mat-label>
    <mat-chip-grid #chipList aria-label="Taggar" [formArrayName]="keywordsProperty" class="Tag-input">
      <mat-chip-row
        *ngFor="let keyword of keywordArray.controls; index as i"
        [removable]="true"
        (removed)="toggleDeleteCustomAttribute(keywordArray, i)"
        class="Tag-input__tag"
        [class.Tag-input__tag--deleted]="keyword.value.deleted"
      >
        {{ keyword.value.value }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
      <input
        placeholder="Ny tagg..."
        [matChipInputFor]="chipList"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addKeyword($event)"
      />
    </mat-chip-grid>
  </mat-form-field>
</div>

<div *ngIf="customAttributes && INITTED" class="flex flex-col">
  <div class="flex flex-col" [formGroup]="form" *ngIf="customAttributeArray.controls.length">
    <h3 class="mat-headline-6">Egna attribut</h3>
    <div [formArrayName]="customAttributesProperty">
      <div
        class="flex flex-wrap items-center gap-2"
        *ngFor="let attr of customAttributeArray.controls; index as i"
        [formGroupName]="i"
        [class.opacity-50]="attr.get('deleted').value"
      >
        <div class="flex-1">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Nyckel</mat-label>
            <input matInput formControlName="key" />
          </mat-form-field>
        </div>
        <div class="flex-1">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Värde</mat-label>
            <input matInput formControlName="value" />
          </mat-form-field>
        </div>
        <div class="flex-1">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Typ</mat-label>
            <mat-select formControlName="type">
              <mat-option value="simple">Enkel</mat-option>
              <mat-option value="text">Lång</mat-option>
              <mat-option value="json">Json</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-none pb-4">
          <button mat-icon-button color="warn" (click)="toggleDeleteCustomAttribute(customAttributeArray, i)" type="button">
            <mat-icon>{{ attr.get('deleted').value ? 'restore_from_trash' : 'delete' }}</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <h3 class="mat-headline-6">Nytt attribut</h3>
  <div class="flex flex-wrap gap-2" [formGroup]="customForm">
    <div class="flex-1">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Nyckel</mat-label>
        <input matInput formControlName="key" />
      </mat-form-field>
    </div>
    <div class="flex-1">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Värde</mat-label>
        <input matInput formControlName="value" />
      </mat-form-field>
    </div>
    <div class="flex-1">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Typ</mat-label>
        <mat-select formControlName="type">
          <mat-option value="simple">Enkel</mat-option>
          <mat-option value="text">Lång</mat-option>
          <mat-option value="json">Json</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex-none">
      <button mat-fab color="primary" type="button" [disabled]="customForm.invalid" (click)="addCustomAttribute(customForm.value)">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
    </div>
  </div>
</div>

<ng-template #colorPickerTemplate let-attr="attr" let-index="index">
  <div [formGroup]="form">
    <div [formArrayName]="property">
      <div [formGroupName]="index">
        <mat-form-field appearance="fill" formGroupName="attribute" class="w-full">
          <mat-label>{{ attr.get('config').value.label | translate }}</mat-label>
          <input matInput [formControlName]="attr.get('config').value.attributeType" type="color" />
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #textFieldTemplate let-attr="attr" let-index="index">
  <div [formGroup]="form">
    <div [formArrayName]="property">
      <div [formGroupName]="index">
        <mat-form-field appearance="fill" formGroupName="attribute" class="w-full">
          <mat-label>{{ attr.get('config').value.label | translate }}</mat-label>
          <input
            matInput
            [formControlName]="attr.get('config').value.attributeType"
            [type]="attr.get('config').value.textType ? attr.get('config').value.textType : 'text'"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #textAreaTemplate let-attr="attr" let-index="index">
  <div [formGroup]="form">
    <div [formArrayName]="property">
      <div [formGroupName]="index">
        <mat-form-field appearance="fill" formGroupName="attribute" class="w-full">
          <mat-label>{{ attr.get('config').value.label | translate }}</mat-label>
          <textarea matInput [formControlName]="attr.get('config').value.attributeType" cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #selectTemplate let-attr="attr" let-index="index">
  <div [formGroup]="form">
    <div [formArrayName]="property">
      <div [formGroupName]="index">
        <mat-form-field appearance="fill" formGroupName="attribute" class="w-full">
          <mat-label>{{ attr.get('config').value.label | translate }}</mat-label>
          <mat-select [formControlName]="attr.get('config').value.attributeType">
            <mat-option *ngFor="let option of attr.get('config').value.selectOptions.options" [value]="option.value">{{
              option.label
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>
